const formatMeters = (meters) => {
  if (meters < 10000) {
    return { value: Math.round(meters), unit: 'm' };
  } else {
    return { value: (meters / 1000).toFixed(2), unit: 'km' };
  }
};

export default formatMeters;
